import Constants from "./Constants";

/**
 * Get all menu items for unified search functionality
 * @param {string} userEmail - User's email for URL construction
 * @param {Object} dynamicItems - Dynamic items (gurusList, countriesList)
 * @returns {Array} Array of menu item objects
 */
export const getMenuItems = (userEmail = "", dynamicItems = {}) => {
  const { gurusList = [], countriesList = [] } = dynamicItems;

  const staticMenuItems = [
    // My Lists
    {
      type: "menu",
      title: "Favorites",
      category: "My Lists",
      navigationType: "url_based",
      urlTemplate: Constants.SCREENER_URL + "Favorites?userEmail={userEmail}",
      displayState: "screener",
      keywords: ["favorites", "watchlist", "my lists", "watch list"],
    },
    {
      type: "menu",
      title: "My Portfolio",
      category: "My Lists",
      navigationType: "special",
      specialHandler: "myPortfolio",
      keywords: ["portfolio", "my portfolio"],
    },

    // Index Stocks
    {
      type: "menu",
      title: "Index and Sector Tracker",
      category: "Index Stocks",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "Index and Sector Tracker?userEmail={userEmail}",
      displayState: "etf_screener",
      searchValue: "Index and Sector Tracker",
      keywords: ["index", "sector tracker", "etf tracker"],
    },
    {
      type: "menu",
      title: "S&P 500 Index Stocks",
      category: "Index Stocks",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "sp500_constituent",
      keywords: ["s&p 500", "sp500", "s and p 500", "sp 500"],
    },
    {
      type: "menu",
      title: "Dow Jones Index Stocks",
      category: "Index Stocks",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "dowjones_constituent",
      keywords: ["dow jones", "dow", "djia"],
    },
    {
      type: "menu",
      title: "NASDAQ Index Stocks",
      category: "Index Stocks",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "nasdaq_constituent",
      keywords: ["nasdaq", "nasdaq index"],
    },
    {
      type: "menu",
      title: "Russell Small Cap Index Stocks",
      category: "Index Stocks",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Russell Small Cap 2000 Stocks",
      keywords: ["russell", "russell small cap", "small cap", "russell 2000"],
    },

    // Investment Ideas
    {
      type: "menu",
      title: "Buy Rated Stocks dipped Today",
      category: "Investment Ideas",
      navigationType: "url_based",
      urlTemplate: Constants.SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Buy Rated Stocks dipped Today",
      keywords: ["buy rated", "dipped today", "buy"],
    },
    {
      type: "menu",
      title: "Best of All",
      category: "Investment Ideas",
      navigationType: "url_based",
      urlTemplate: Constants.SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Bestofall",
      keywords: ["best of all", "best", "top stocks"],
    },
    {
      type: "menu",
      title: "Top 50 Value Stocks",
      category: "Investment Ideas",
      navigationType: "url_based",
      urlTemplate: Constants.SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "top50",
      keywords: ["top 50", "value stocks", "value"],
    },
    {
      type: "menu",
      title: "Large Cap Growth",
      category: "Investment Ideas",
      navigationType: "url_based",
      urlTemplate: Constants.SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "largeCap",
      keywords: ["large cap", "growth", "large cap growth"],
    },
    {
      type: "menu",
      title: "Great Small & Mid size Companies",
      category: "Investment Ideas",
      navigationType: "url_based",
      urlTemplate: Constants.SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "smallMid",
      keywords: ["small mid", "small cap", "mid cap", "small companies"],
    },
    {
      type: "menu",
      title: "Gems under $20",
      category: "Investment Ideas",
      navigationType: "url_based",
      urlTemplate: Constants.SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "gems20",
      keywords: ["gems", "under 20", "cheap stocks", "low price"],
    },
    {
      type: "menu",
      title: "Good Dividend Stocks",
      category: "Investment Ideas",
      navigationType: "url_based",
      urlTemplate: Constants.SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "dividend",
      keywords: ["dividend", "dividend stocks", "income"],
    },
    {
      type: "menu",
      title: "Speculative Growth Stocks",
      category: "Investment Ideas",
      navigationType: "url_based",
      urlTemplate: Constants.SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "speculative",
      keywords: ["speculative", "growth", "speculative growth"],
    },
    {
      type: "menu",
      title: "High Performing Stocks",
      category: "Investment Ideas",
      navigationType: "url_based",
      urlTemplate: Constants.SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "highPFStocks",
      keywords: ["high performing", "performance", "best performers"],
    },
    {
      type: "menu",
      title: "High Profit Margin Stocks",
      category: "Investment Ideas",
      navigationType: "url_based",
      urlTemplate: Constants.SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "highProfitMargin",
      keywords: ["profit margin", "high margin", "profitable"],
    },

    // Model Portfolios - Static
    {
      type: "menu",
      title: "FAANG",
      category: "Model Portfolios",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "FAANG",
      keywords: ["faang", "facebook amazon apple netflix google"],
    },
    {
      type: "menu",
      title: "Magnificent 7",
      category: "Model Portfolios",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Magnificent 7",
      keywords: ["magnificent 7", "mag 7", "top 7"],
    },
    {
      type: "menu",
      title: "TAMANA",
      category: "Model Portfolios",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "TAMANA",
      keywords: ["tamana"],
    },

    // Screeners - Sectors
    {
      type: "menu",
      title: "Technology",
      category: "Screeners > Sectors",
      navigationType: "url_based",
      urlTemplate: Constants.SECTOR_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Technology",
      keywords: ["technology", "tech", "sector"],
    },
    {
      type: "menu",
      title: "Basic Materials",
      category: "Screeners > Sectors",
      navigationType: "url_based",
      urlTemplate: Constants.SECTOR_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Basic Materials",
      keywords: ["basic materials", "materials", "sector"],
    },
    {
      type: "menu",
      title: "Communication Services",
      category: "Screeners > Sectors",
      navigationType: "url_based",
      urlTemplate: Constants.SECTOR_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Communication Services",
      keywords: ["communication", "telecom", "sector"],
    },
    {
      type: "menu",
      title: "Consumer Cyclical",
      category: "Screeners > Sectors",
      navigationType: "url_based",
      urlTemplate: Constants.SECTOR_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Consumer Cyclical",
      keywords: ["consumer cyclical", "cyclical", "sector"],
    },
    {
      type: "menu",
      title: "Consumer Defensive",
      category: "Screeners > Sectors",
      navigationType: "url_based",
      urlTemplate: Constants.SECTOR_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Consumer Defensive",
      keywords: ["consumer defensive", "defensive", "sector"],
    },
    {
      type: "menu",
      title: "Energy",
      category: "Screeners > Sectors",
      navigationType: "url_based",
      urlTemplate: Constants.SECTOR_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Energy",
      keywords: ["energy", "oil", "gas", "sector"],
    },
    {
      type: "menu",
      title: "Financial",
      category: "Screeners > Sectors",
      navigationType: "url_based",
      urlTemplate: Constants.SECTOR_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Financial",
      keywords: ["financial", "finance", "banking", "sector"],
    },
    {
      type: "menu",
      title: "Healthcare",
      category: "Screeners > Sectors",
      navigationType: "url_based",
      urlTemplate: Constants.SECTOR_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Healthcare",
      keywords: ["healthcare", "health", "medical", "sector"],
    },
    {
      type: "menu",
      title: "Industrials",
      category: "Screeners > Sectors",
      navigationType: "url_based",
      urlTemplate: Constants.SECTOR_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Industrials",
      keywords: ["industrials", "industrial", "sector"],
    },
    {
      type: "menu",
      title: "Real Estate",
      category: "Screeners > Sectors",
      navigationType: "url_based",
      urlTemplate: Constants.SECTOR_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Real Estate",
      keywords: ["real estate", "reit", "sector"],
    },

    // Screeners - Industries
    {
      type: "menu",
      title: "Residential Construction",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.INDUSTRY_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Residential Construction",
      keywords: ["residential construction", "construction", "homebuilding"],
    },
    {
      type: "menu",
      title: "Restaurants",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.INDUSTRY_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Restaurants",
      keywords: ["restaurants", "dining", "food"],
    },
    {
      type: "menu",
      title: "Lodging",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.INDUSTRY_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Lodging",
      keywords: ["lodging", "hotels", "hospitality"],
    },
    {
      type: "menu",
      title: "Airlines",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.INDUSTRY_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Airlines",
      keywords: ["airlines", "airline", "aviation"],
    },
    {
      type: "menu",
      title: "Resorts & Casinos",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.INDUSTRY_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Resorts & Casinos",
      keywords: ["resorts", "casinos", "gaming"],
    },
    {
      type: "menu",
      title: "Travel & Leisure",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.INDUSTRY_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Travel & Leisure",
      keywords: ["travel", "leisure", "tourism"],
    },
    {
      type: "menu",
      title: "Travel Services",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.INDUSTRY_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Travel Services",
      keywords: ["travel services", "travel"],
    },
    {
      type: "menu",
      title: "Grocery Stores",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.INDUSTRY_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Grocery Stores",
      keywords: ["grocery", "groceries", "supermarket"],
    },
    {
      type: "menu",
      title: "Discount Stores",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.INDUSTRY_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Discount Stores",
      keywords: ["discount stores", "discount", "retail"],
    },
    {
      type: "menu",
      title: "Semiconductor",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.INDUSTRY_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Semiconductor",
      keywords: ["semiconductor", "chips", "semiconductors"],
    },
    {
      type: "menu",
      title: "Pharma Companies",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Pharma Companies",
      keywords: ["pharma", "pharmaceutical", "drugs"],
    },
    {
      type: "menu",
      title: "Shell Companies",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.SECTOR_SCREENER_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Shell Companies",
      keywords: ["shell companies", "shell"],
    },
    {
      type: "menu",
      title: "Cannabis",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Cannabis",
      keywords: ["cannabis", "marijuana", "weed"],
    },
    {
      type: "menu",
      title: "Space Exploration",
      category: "Screeners > Industries",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Space Exploration",
      keywords: ["space", "space exploration", "aerospace"],
    },

    // Screeners - EV Related
    {
      type: "menu",
      title: "Electric Vehicles",
      category: "Screeners > EV Related",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Electric Vehicles",
      keywords: ["electric vehicles", "ev", "electric cars"],
    },
    {
      type: "menu",
      title: "Battery-Charging",
      category: "Screeners > EV Related",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Battery-Charging",
      keywords: ["battery", "charging", "ev battery"],
    },
    {
      type: "menu",
      title: "Natural Resources",
      category: "Screeners > EV Related",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Natural Resources",
      keywords: ["natural resources", "resources", "mining"],
    },
    {
      type: "menu",
      title: "LIDAR",
      category: "Screeners > EV Related",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "LIDAR",
      keywords: ["lidar", "sensors", "autonomous"],
    },
    {
      type: "menu",
      title: "EV Resources",
      category: "Screeners > EV Related",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "EV Resources",
      keywords: ["ev resources", "ev"],
    },

    // Screeners - Clean Energy
    {
      type: "menu",
      title: "Solar",
      category: "Screeners > Clean Energy",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Solar",
      keywords: ["solar", "solar energy", "renewable"],
    },
    {
      type: "menu",
      title: "Fuel Cell",
      category: "Screeners > Clean Energy",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Fuel Cell",
      keywords: ["fuel cell", "hydrogen", "clean energy"],
    },

    // Screeners - Speciality Tech
    {
      type: "menu",
      title: "Quantum Pure-play",
      category: "Screeners > Speciality Tech",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Quantum Pure-play",
      keywords: ["quantum", "quantum computing", "qc"],
    },
    {
      type: "menu",
      title: "Data Tech",
      category: "Screeners > Speciality Tech",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Data Tech",
      keywords: ["data tech", "data", "big data"],
    },
    {
      type: "menu",
      title: "Internet Retail",
      category: "Screeners > Speciality Tech",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Internet Retail",
      keywords: ["internet retail", "ecommerce", "online retail"],
    },
    {
      type: "menu",
      title: "Health Tech",
      category: "Screeners > Speciality Tech",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Health Tech",
      keywords: ["health tech", "healthtech", "digital health"],
    },
    {
      type: "menu",
      title: "Real Estate Tech",
      category: "Screeners > Speciality Tech",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Real Estate Tech",
      keywords: ["real estate tech", "proptech", "property tech"],
    },
    {
      type: "menu",
      title: "Fin Tech",
      category: "Screeners > Speciality Tech",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Fin Tech",
      keywords: ["fintech", "financial tech", "fin tech"],
    },
    {
      type: "menu",
      title: "Bio Tech",
      category: "Screeners > Speciality Tech",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Bio Tech",
      keywords: ["biotech", "biotechnology", "bio tech"],
    },
    {
      type: "menu",
      title: "Cloud Tech",
      category: "Screeners > Speciality Tech",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Cloud Tech",
      keywords: ["cloud tech", "cloud computing", "saas"],
    },
    {
      type: "menu",
      title: "5G Tech",
      category: "Screeners > Speciality Tech",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "5g Tech",
      keywords: ["5g", "5g tech", "wireless"],
    },
    {
      type: "menu",
      title: "AI Robotics Tech",
      category: "Screeners > Speciality Tech",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "AI Robotics Tech",
      keywords: ["ai robotics", "robotics", "ai", "artificial intelligence"],
    },
    {
      type: "menu",
      title: "Advertisement Tech",
      category: "Screeners > Speciality Tech",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Advertisement Tech",
      keywords: ["adtech", "advertisement tech", "advertising"],
    },

    // Screeners - Other
    {
      type: "menu",
      title: "Led by Indian CEOs",
      category: "Screeners > Other",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "Led by Indian CEOs",
      keywords: ["indian ceos", "ceo", "leadership"],
    },
    {
      type: "menu",
      title: "GLP-1 Drug Companies",
      category: "Screeners > Other",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "GLP-1 Drug Companies",
      keywords: ["glp-1", "drug companies", "pharma"],
    },
    {
      type: "menu",
      title: "IPOs in last one year",
      category: "Screeners > Other",
      navigationType: "url_based",
      urlTemplate: Constants.RECENT_IPOS_URL + "?userEmail={userEmail}",
      displayState: "screener",
      searchValue: "",
      keywords: ["ipos", "recent ipos", "initial public offering"],
    },

    // Tools
    {
      type: "menu",
      title: "Portfolio Leaderboard",
      category: "Tools",
      navigationType: "state_only",
      stateUpdate: { showPortfolioLeaderboard: true },
      keywords: ["portfolio leaderboard", "leaderboard", "performance"],
    },
    {
      type: "menu",
      title: "Compare Stocks",
      category: "Tools",
      navigationType: "special",
      specialHandler: "compareStocks",
      keywords: ["compare stocks", "compare", "comparison"],
    },
    {
      type: "menu",
      title: "IPO Calendar",
      category: "Tools",
      navigationType: "state_only",
      stateUpdate: { showIPO: true },
      keywords: ["ipo calendar", "ipo", "calendar"],
    },
    {
      type: "menu",
      title: "Earnings Calendar",
      category: "Tools",
      navigationType: "state_only",
      stateUpdate: { showEarningsCal: true },
      keywords: ["earnings calendar", "earnings", "calendar"],
    },
    {
      type: "menu",
      title: "What If Calculator",
      category: "Tools",
      navigationType: "state_only",
      stateUpdate: { showWhatIfCalculator: true },
      keywords: ["what if calculator", "calculator", "what if"],
    },
    {
      type: "menu",
      title: "Latest News",
      category: "Tools",
      navigationType: "state_only",
      stateUpdate: { showNews: true },
      keywords: ["news", "latest news", "news feed"],
    },

    // Help
    {
      type: "menu",
      title: "Site Help",
      category: "Help",
      navigationType: "state_only",
      stateUpdate: { showHelp: true },
      keywords: ["help", "site help", "support"],
    },
    {
      type: "menu",
      title: "What's New",
      category: "Help",
      navigationType: "state_only",
      stateUpdate: { showReleaseNotes: true },
      keywords: ["what's new", "release notes", "updates", "changelog"],
    },
    {
      type: "menu",
      title: "Submit Feature",
      category: "Help",
      navigationType: "state_only",
      stateUpdate: { showSubmitFeature: true },
      keywords: ["submit feature", "feature request", "feedback"],
    },

    // Navigation
    {
      type: "menu",
      title: "Home",
      category: "Navigation",
      navigationType: "special",
      specialHandler: "reloadHomePage",
      keywords: ["home", "main", "index"],
    },
  ];

  // Add dynamic SS Picks (Investment Ideas)
  const ssPicks = gurusList
    .filter((item) => item.type === "SS List")
    .map((item) => ({
      type: "menu",
      title: item.guru,
      category: "Investment Ideas > SS Picks",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: item.guru,
      keywords: [item.guru.toLowerCase(), "ss picks", "ss list"],
    }));

  // Add dynamic Investment Gurus (Model Portfolios)
  const investmentGurus = gurusList
    .filter((item) => item.type === "Investment Guru")
    .map((item) => ({
      type: "menu",
      title: item.guru,
      category: "Model Portfolios > Gurus",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: item.guru,
      keywords: [item.guru.toLowerCase(), "guru", "investment guru"],
    }));

  // Add dynamic Social Media Watch Lists (Model Portfolios)
  const socialMediaLists = gurusList
    .filter((item) => item.type === "Watch List")
    .map((item) => ({
      type: "menu",
      title: item.guru,
      category: "Model Portfolios > Social Media",
      navigationType: "url_based",
      urlTemplate: Constants.COATTAIL_URL + "{name}?userEmail={userEmail}",
      displayState: "screener",
      searchValue: item.guru,
      keywords: [item.guru.toLowerCase(), "social media", "watch list"],
    }));

  // Add dynamic Countries (Screeners)
  const countryItems = countriesList.map((item) => ({
    type: "menu",
    title: item.value,
    category: "Screeners > Countries",
    navigationType: "url_based",
    urlTemplate: Constants.COUNTRY_URL + "{name}?userEmail={userEmail}",
    displayState: "screener",
    searchValue: item.value,
    countryCode: item.code,
    keywords: [item.value.toLowerCase(), item.code.toLowerCase(), "country"],
  }));

  // Combine all items
  return [
    ...staticMenuItems,
    ...ssPicks,
    ...investmentGurus,
    ...socialMediaLists,
    ...countryItems,
  ];
};

export default getMenuItems;
